import { times } from 'lodash'
import { useEffect, useState } from 'react'
import { twMerge as twm } from 'tailwind-merge'

type Props = {
    className?: string
    dotClassName?: string
    size?: 'small' | 'large'
}

export const Dots = ({ className, dotClassName, size = 'small' }: Props) => {
    const [numDots, setNumDots] = useState(3)

    useEffect(() => {
        const intervalID = setInterval(() => {
            setNumDots((prevNum) => (prevNum === 3 ? 1 : prevNum + 1))
        }, 300)

        return () => clearInterval(intervalID)
    }, [])

    return (
        <div
            className={twm(
                'inline-flex items-center justify-center',
                size === 'small' ? 'gap-x-0.5' : 'gap-x-2',
                className
            )}
        >
            {times(numDots, (dotNum) => (
                <span
                    key={dotNum}
                    className={twm(
                        'size-1 rounded-full bg-current',
                        size === 'small' ? 'size-1' : 'size-4',
                        dotClassName
                    )}
                />
            ))}
        </div>
    )
}
